import { NgModule } from '@angular/core';
import { TruncatePipe } from './pipes/truncate-pipe';
import { LibelleEtatPdpPipe } from './pipes/libelle-etat-pdp-pipe';
import { LibelleValiditePdpPipe } from './pipes/libelle-validite-pdp.pipe';
import { DisplayNbJoursAvantExpirationPipe } from './pipes/display-nb-jours-avant-expiration';
import { LibelleTypePdpPipe } from './pipes/libelle-type-pdp-pipe';
import { ActionTitleForPdpPipe } from './pipes/display-action-title-for-pdp';
import { LibelleEtatPaPipe } from './pipes/libelle-etat-pa-pipe';
import { LibelleValiditePaPipe } from './pipes/libelle-validite-pa.pipe';
import { ActionTitleForPaPipe } from './pipes/display-action-title-for-pa';

@NgModule({
	declarations: [
		TruncatePipe,
		LibelleEtatPdpPipe,
		LibelleTypePdpPipe,
		LibelleValiditePdpPipe,
		DisplayNbJoursAvantExpirationPipe,
		ActionTitleForPdpPipe,
		LibelleEtatPaPipe,
		LibelleValiditePaPipe,
		ActionTitleForPaPipe
	],
	exports: [
		TruncatePipe,
		LibelleEtatPdpPipe,
		LibelleTypePdpPipe,
		LibelleValiditePdpPipe,
		DisplayNbJoursAvantExpirationPipe,
		ActionTitleForPdpPipe,
		LibelleEtatPaPipe,
		LibelleValiditePaPipe,
		ActionTitleForPaPipe
	]
})
export class FormattersModule {
	constructor() { }
}